import React from 'react'

import { Text } from '@wartek-id/text-v1'

import { CoachMark } from 'components/CoachMark'
import {
  useContentSearchFilterOnboarding,
  useContentSearchTracker,
} from 'stores/content-search'
import useSETrackEvent from 'app/SearchPage/hooks/useSETrackEvent'

const ONBOARDING_STEPS = [
  {
    selector: '#coachmark-quick-filters',
    description: null,
    customDescriptionRenderer: () => (
      <Text color="inverse">Anda bisa edit kategori lagi di sini, ya.</Text>
    ),
    disableMaskInteraction: true,
  },
]

const SearchFilterCoachMark = () => {
  const { isFinished, isCoachMarkFinished, setCoachMarkFinished } =
    useContentSearchFilterOnboarding()
  const contentSearchTrackerStore = useContentSearchTracker()
  const { SETrackSearchResultsPage } = useSETrackEvent()
  const isCoachMarkDisplayed = React.useMemo(
    () => isFinished && !isCoachMarkFinished,
    [isCoachMarkFinished, isFinished]
  )

  const finishHandler = React.useCallback(() => {
    setCoachMarkFinished()
    SETrackSearchResultsPage('CLICK_DONE_SEARCH_FILTER_COACHMARK', {
      event_trigger: contentSearchTrackerStore.eventTrigger,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (isCoachMarkDisplayed) {
      SETrackSearchResultsPage('LOAD_SEARCH_FILTER_COACHMARK', {
        event_trigger: contentSearchTrackerStore.eventTrigger,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCoachMarkDisplayed])

  return (
    <CoachMark
      disableClose={true}
      disableCloseOnClick={false}
      disablePrev={true}
      isOpen={isCoachMarkDisplayed}
      rootSelector="html"
      steps={ONBOARDING_STEPS}
      onFinish={finishHandler}
      tooltipConfigs={{
        closeLabel: 'Siap',
      }}
      maskRadius={8}
      maskPadding={10}
    />
  )
}

export default SearchFilterCoachMark
